<form [formGroup]="searchForm">
  <div style="{{ style }}">
    <mat-form-field>
      <mat-label>{{ title || "input-client-name" | translate }}</mat-label
      ><input
        *ngIf="required; else optionalField"
        type="text"
        matInput
        required
        formControlName="client"
        [placeholder]="placeholder"
        [matAutocomplete]="auto"
      />
      <ng-template #optionalField>
        <input
          type="text"
          matInput
          formControlName="client"
          [placeholder]="placeholder"
          [matAutocomplete]="auto"
        />
      </ng-template>
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let client of clients$ | async"
          (onSelectionChange)="handleChangeClient($event, client)"
          [value]="client.tradingName"
          class="autocomplete"
        >
          {{ client.tradingName }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          this.searchForm.controls.client.touched && !this.searchForm.valid
        "
        >{{ requiredText || "required-client" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
